import { useEffect, useState } from "react";

export const SplashScreen = () => {
  const [hidden, setHidden] = useState(false);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setHidden(true), 900);
    const t2 = setTimeout(() => setGone(true), 1400);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (gone) return null;

  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-secondary transition-opacity duration-500 ${hidden ? "pointer-events-none opacity-0" : "opacity-100"}`}
    >
      <img
        src="/logo192.png"
        alt="PanierMoinsCher"
        className="h-24 w-24 rounded-3xl shadow-2xl"
        style={{ animation: "splashPop 700ms cubic-bezier(0.22,1,0.36,1)" }}
      />
      <p className="mt-5 font-display text-xl font-800 tracking-tight text-white">
        Panier<span className="text-primary">MoinsCher</span>
      </p>
      <div className="mt-4 h-1 w-28 overflow-hidden rounded-full bg-white/15">
        <div className="h-full w-1/2 rounded-full bg-primary" style={{ animation: "splashBar 900ms ease-in-out infinite" }} />
      </div>
      <style>{`
        @keyframes splashPop { 0% { transform: scale(0.6); opacity: 0; } 60% { transform: scale(1.08); opacity: 1; } 100% { transform: scale(1); } }
        @keyframes splashBar { 0% { transform: translateX(-120%); } 100% { transform: translateX(240%); } }
      `}</style>
    </div>
  );
};
